import routes from './routes';
import RenderRoutes from './RenderRoutes.jsx';
import Root from './Root.jsx';

export { routes, RenderRoutes, Root };



// WEBPACK FOOTER //
// ./routes/index.js